import { render, staticRenderFns } from "./Paid.vue?vue&type=template&id=89b14742&scoped=true&lang=pug&"
import script from "./Paid.vue?vue&type=script&lang=js&"
export * from "./Paid.vue?vue&type=script&lang=js&"
import style0 from "./Paid.scss?vue&type=style&index=0&id=89b14742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b14742",
  null
  
)

export default component.exports